import '../../../../../vendor/assets/javascripts/jquery.payment';

function applyCreditCardInputMask() {
  $('[data-credit-card-number]').payment('formatCardNumber');
}

function applyExpMonthInputMask() {
  $('[data-credit-card-expiration-month]').payment('restrictNumeric');
}

function applyExpYearInputMask() {
  $('[data-credit-card-expiration-year]').payment('restrictNumeric');
}

function applyCVVInputMask() {
  $('[data-credit-card-cvv]').payment('formatCardCVC');
}

function init() {
  applyCreditCardInputMask();
  applyExpMonthInputMask();
  applyExpYearInputMask();
  applyCVVInputMask();
}

document.addEventListener('DOMContentLoaded', init);

export default { init };



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/input_mask.js